import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Router, ActivatedRoute } from '@angular/router';
import { MarinaCompany } from '../_models/marina-company.model';
import { Empresa } from '../_models/finances/empresa';
import { Usuario } from '../_models/finances/usuario';

export interface IRequestOptions {
    headers?: HttpHeaders;
    observe?: 'body';
    params?: HttpParams;
    reportProgress?: boolean;
    responseType?: 'json';
    withCredentials?: boolean;
    body?: any;
}

export function easyMarineHttpFinancesCreator(http: HttpClient, router: Router, route: ActivatedRoute) {
    // tslint:disable-next-line: no-use-before-declare
    return new EasyMarineHttpFinances(http, router, route);
}

@Injectable()
export class EasyMarineHttpFinances {

    // Extending the HttpClient through the Angular DI.
    public constructor(private http: HttpClient, private router: Router, private route: ActivatedRoute) {
    }

    /**
     * GET request
     * @param endPoint it doesn't need / in front of the end point
     * @param options options of the request like headers, body, etc.
     * @returns Observable<T>
     */
    public get<T>(endPoint: string, options?: IRequestOptions, additionalCompany?: MarinaCompany): Observable<T> {
        return this.http.get<T>(endPoint, this.createRequestOptions(options, additionalCompany));
    }

    /**
     * POST request
     * @param endPoint end point of the api
     * @param params body of the request.
     * @param options options of the request like headers, body, etc.
     * @returns Observable<T>
     */
    public post<T>(endPoint: string, params: object, options?: IRequestOptions, additionalCompany?: MarinaCompany): Observable<T> {
        return this.http.post<T>(endPoint, params, this.createRequestOptions(options, additionalCompany));
    }

    /**
     * PUT request
     * @param endPoint end point of the api
     * @param params body of the request.
     * @param options options of the request like headers, body, etc.
     * @returns Observable<T>
     */
    public put<T>(endPoint: string, params: object, options?: IRequestOptions, additionalCompany?: MarinaCompany): Observable<T> {
        return this.http.put<T>(endPoint, params, this.createRequestOptions(options, additionalCompany));
    }

    /**
     * DELETE request
     * @param endPoint end point of the api
     * @param options options of the request like headers, body, etc.
     * @returns Observable<T>
     */
    public delete<T>(endPoint: string, options?: IRequestOptions, additionalCompany?: MarinaCompany): Observable<T> {
        return this.http.delete<T>(endPoint, this.createRequestOptions(options, additionalCompany));
    }

    private createRequestOptions(options: IRequestOptions, additionalCompany?: MarinaCompany) {
        if (options === undefined) {
            options = {};
        }
        const currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (currentUser && currentUser.token) {
            const httpOptions = new HttpHeaders({
                'authorization': 'Basic ' + this.getTokenFinanceiro(currentUser, additionalCompany),
                'Access-Control-Allow-Origin': '*'
            });
            options.headers = httpOptions;
        } else {
            this.router.navigate(['login']);
        }
        return options;
    }

    private getTokenFinanceiro(currentUser, company?: MarinaCompany): string {

        const empresaUser: Empresa = {
            codigo: 1000 + currentUser.marina.id,
            nome: currentUser.marina.companyName,
            fantasia: currentUser.marina.companyName,
            cnpj: currentUser.marina.companyFederalId.replace(/[^a-zA-Z0-9]/g, ''),
            tipoSistema: 'PORTALPOSTAL'
        };
        if (company) {
            empresaUser.nome = company.companyName;
            empresaUser.fantasia = company.companyFederalName;
            empresaUser.cnpj = company.companyFederalId.replace(/[^a-zA-Z0-9]/g, '');
        } else {
            let c;
            if (this.router && this.router.url && this.router.url.includes('company=')) {
                c = this.route.snapshot.queryParams.get('company');
            }
            if (c) {
                const marinaCompany = currentUser.marina.marinaCompanies.filter((m) => m.companyFederalId === c);
                if (marinaCompany) {
                    empresaUser.nome = marinaCompany.companyName;
                    empresaUser.fantasia = marinaCompany.companyFederalName;
                    empresaUser.cnpj = marinaCompany.companyFederalId.replace(/[^a-zA-Z0-9]/g, '');
                }
            }
        }

        const usuario: Usuario = {
            codigo: currentUser.id,
            nome: currentUser.firstName,
            login: currentUser.username,
            perfil: '0',
            empresa: empresaUser,
            bancoDados: empresaUser.cnpj
        };

        return btoa(JSON.stringify(usuario));
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/_utils/easy-marine-http-finances.ts